var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSkipBack = function SvgIconSkipBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.25 3.75a1 1 0 0 0-2 0v16.5a1 1 0 1 0 2 0v-6.47l10.831 6.627.002.002a1.75 1.75 0 0 0 2.667-1.504V5.095a1.749 1.749 0 0 0-2.667-1.504l-.002.002L6.25 10.22zM7.174 12 17.75 5.528v12.944z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSkipBack;